import React from 'react';
import cn from 'classnames';

import styles from './scale.module.scss';

interface IProps {
  className?: string;
  id?: string;
  value?: string;
  checked?: boolean;
  name?: string;
  label?: string;
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

const RadioInput: React.FC<IProps> = (props) => {
  const { className, id, value, checked, name, label, onChange } = props;

  return (
    <label className={cn(styles.input__label, className)} htmlFor={id}>
      <input
        id={id}
        className={styles.input}
        type='radio'
        name={name}
        value={value}
        checked={checked}
        onChange={onChange}
      />
      <span className={styles.input__name}>{label}</span>
    </label>
  );
};

export default RadioInput;
